import { OPTIONS } from '@shared/const/globals.const';
import { PaginatedData } from '@shared/models/paginated-data';

export const TaskOperations = {
  REQUEST_REAL_PROGRAMS: 'REQUEST_REAL_PROGRAMS',
  REQUEST_CALENDARS: 'REQUEST_CALENDARS',
  REQUEST_DOCTOR_AGENDAS: 'REQUEST_DOCTOR_AGENDAS',
  REQUEST_SURGEON_OPENINGS: 'REQUEST_SURGEON_OPENINGS',
  CYCLE_PLANNING: 'CYCLE_PLANNING',
  TVO: 'TVO',
  ANESTH_NEEDS: 'ANESTH_NEEDS',
  EXPORT: 'EXPORT',
  STATS: 'STATS',
  CORRESPONDANCES: 'CORRESPONDANCES',
  CAMPAIGN_PLANNING: 'CAMPAIGN_PLANNING',
  ADJUSTMENT_PLANNING: 'ADJUSTMENT_PLANNING',
  EXPORT_PROFILES_REPORTS: 'EXPORT_PROFILES_REPORTS',
};

export type TaskOperationsEnum = (typeof TaskOperations)[keyof typeof TaskOperations];

export const TaskStatuses = {
  QUEUED: 'queued',
  RUNNING: 'running',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  CANCELED: 'canceled',
};

export const OPTIONS_TO_TASK_OPERATION: Partial<Record<keyof typeof OPTIONS, TaskOperationsEnum[]>> = {
  PROGRAMS_DATA_PIPELINE: [TaskOperations.REQUEST_REAL_PROGRAMS, TaskOperations.REQUEST_DOCTOR_AGENDAS],
  VACATIONS_DATA_PIPELINE: [TaskOperations.REQUEST_SURGEON_OPENINGS],
  CALENDARS_DATA_PIPELINE: [TaskOperations.REQUEST_CALENDARS],
};

export interface Task {
  _id: string;
  hospital?: string;
  operation: string;
  data?: any;
  createdBy?: string;
  startedAt?: Date;
  error?: string;
  status?: 'queued' | 'running' | 'succeeded' | 'failed' | 'canceled';
  steps?: any[];
  createdAt: Date;
  updatedAt: Date;
  notifiedUsers?: string[];
}

export type TasksPaginatedResponse = PaginatedData<Task>;
